import { SearchableItem } from '../models/searchable-item.model';
import {
  SearchStrategy,
  ScoredMatch,
  StrategyContext,
  StrategyId,
} from '../models/search-strategy.model';

/**
 * Shared helpers for all scoring strategies. Strategies don't have to extend
 * this — they just need to implement SearchStrategy — but this keeps common
 * normalization in one place.
 */
export abstract class BaseSearchStrategy implements SearchStrategy {
  abstract readonly id: StrategyId;
  abstract readonly defaultWeight: number;

  abstract score<T>(
    item: SearchableItem<T>,
    ctx: StrategyContext
  ): ScoredMatch | null;

  protected normalizedTitle<T>(item: SearchableItem<T>): string {
    return item._normalizedTitle ?? item.title.toLowerCase();
  }

  protected normalizedDescription<T>(item: SearchableItem<T>): string {
    return item._normalizedDescription ?? item.description.toLowerCase();
  }

  protected normalizedKeywords<T>(item: SearchableItem<T>): string[] {
    return (
      item._normalizedKeywords ?? item.keywords.map((k) => k.toLowerCase())
    );
  }

  protected match(
    strategyId: StrategyId,
    score: number,
    evidence?: string
  ): ScoredMatch | null {
    if (score <= 0) return null;
    return { strategyId, score, evidence };
  }
}
